import { Component, Vue } from 'vue-property-decorator';
import SideNavigation from '@/components/SideNavigation/SideNavigation';
import { request } from '@/tools/request';

@Component<Unsubscribe>({
  components: {
    SideNavigation,
  },
})
export default class Unsubscribe extends Vue {
  protected schoolClasses: any = [];
  protected classOne: any = [];
  protected classTwo: any = [];
  protected classThree: any = [];
  protected currentlyLoading: boolean = false;
  protected classLoading: boolean = true;

  public mounted() {
    this.getClasses();
  }

  protected getClasses() {
    request('get', 'https://us-central1-lexlibris-api.cloudfunctions.net/webApi/classes').then(
      (response: any) => {
        this.classLoading = false;
        this.classOne = [];
        this.classTwo = [];
        this.classThree = [];
        let classLoopIndex: number = 0;
        response.data.forEach((element: any, index: any) => {
          if (element.data.class === '1 A') this.classOne.push(element);
          if (element.data.class === '1 B') this.classTwo.push(element);
          if (element.data.class === '1 C') this.classThree.push(element);
          classLoopIndex = index + 1;
          if (classLoopIndex === response.data.length) {
            this.fillClassesArray();
          }
        });
      },
      (error: any) => {
        console.log('request error', error);
      }
    );
  }

  protected fillClassesArray() {
    this.schoolClasses = [{
      class: '1ºA',
      className: '1 A',
      registered: this.countStudents(this.classOne, 'enrolled'),
      pending: this.countStudents(this.classOne, 'pending'),
      notEnrolled: this.countStudents(this.classOne, 'not enrolled'),
      students: this.classOne,
    }, {
      class: '1ºB',
      className: '1 B',
      registered: this.countStudents(this.classTwo, 'enrolled'),
      pending: this.countStudents(this.classTwo, 'pending'),
      notEnrolled: this.countStudents(this.classTwo, 'not enrolled'),
      students: this.classTwo,
    }, {
      class: '1ºC',
      className: '1 C',
      registered: this.countStudents(this.classThree, 'enrolled'),
      pending: this.countStudents(this.classThree, 'pending'),
      notEnrolled: this.countStudents(this.classThree, 'not enrolled'),
      students: this.classThree,
    }]
  }

  protected countStudents(array: any, status: string) {
    let count: number = 0;
    array.forEach((item: any) => {
      if (item.data.status === status) count = count + 1;
    });
    return count;
  }

  protected unsubAllClasses(enrollClass: any) {
    this.currentlyLoading = true;
    const payload: any = {
      id: enrollClass,
      status: 'not enrolled',  
    };

    request('post', 'https://us-central1-lexlibris-api.cloudfunctions.net/webApi/updateClass', payload).then(
      (response: any) => {
        this.getClasses();
        this.currentlyLoading = false;
      },
      (error: any) => {
        console.log('request error', error);
      }
    );
  }

  protected enrollStudent(student: any, status: string) {
    student.data.status = status;
    this.updateStudent(student, status);
  }

  protected updateStudent(student: any, status: string) {
    const payload: any = {
      id: student.id,
      statusUpdate: status,
      studentName: student.data.name,
    };

    console.log(payload);
    request('post', 'https://us-central1-lexlibris-api.cloudfunctions.net/webApi/updateStatus', payload).then(
      (response: any) => {
        //
      },
      (error: any) => {
        console.log('request error', error);
      }
    );
  }

}
